



































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RestaurantAPI } from "@/api/restaurant/restaurant-api";
import {
  IRestaurant,
  IRestaurantTable,
  IRestaurantWall,
} from "@/@types/admin/restourant/restourant";
import { ILocale } from "@/@types/locale";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import { preferred_language } from "@/config/languags.config.json";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, LanguagesButtons },
})
export default class RestorantsConstructior extends Vue {
  restaurants: IRestaurant[] = [];
  selectedRestaurant: IRestaurant | null = null;
  loading = false;

  localTables: IRestaurantTable[] = [];
  localWalls: IRestaurantWall[] = [];
  localPlanWidth = 1360;
  localPlanHeight = 700;
  localPlanBackground = "";

  selectedTableIdx: number | null = null;
  selectedWallIdx: number | null = null;

  showGrid = true;
  snapToGrid = true;
  gridSize = 20;
  hasChanges = false;

  drawingWall: IRestaurantWall["type"] | null = null;
  drawStart = { x: 0, y: 0 };
  drawCurrent = { x: 0, y: 0 };

  showAddModal = false;
  showEditModal = false;
  showRecycler = false;
  recyclerLoading = false;
  recyclerItems: IRestaurant[] = [];
  modalLocale = preferred_language;
  editLocale = preferred_language;
  editData: {
    name: ILocale;
    description: ILocale;
  } = {
    name: { ru: "", en: "" },
    description: { ru: "", en: "" },
  };

  newRestaurant = {
    name: { ru: "", en: "" },
    description: { ru: "", en: "" },
  };

  private dragData: {
    tableIdx: number;
    startMouseX: number;
    startMouseY: number;
    startTableX: number;
    startTableY: number;
  } | null = null;

  private wallDragData: {
    wallIdx: number;
    startMouseX: number;
    startMouseY: number;
    startWallX1: number;
    startWallY1: number;
    startWallX2: number;
    startWallY2: number;
  } | null = null;

  get canvasStyle(): Record<string, string> {
    const bgParts: string[] = [];
    if (this.localPlanBackground) {
      bgParts.push(this.localPlanBackground);
    }
    if (this.showGrid) {
      bgParts.push("radial-gradient(#ddd 1px, transparent 1px)");
    }
    return {
      width: this.localPlanWidth + "px",
      height: this.localPlanHeight + "px",
      background: bgParts.join(", ") || "#fff",
      backgroundSize: this.showGrid ? "20px 20px" : "",
    };
  }

  mounted(): void {
    this.loadRestaurants();
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("mousemove", this.onGlobalMouseMove);
    document.addEventListener("mouseup", this.onGlobalMouseUp);
  }

  beforeDestroy(): void {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("mousemove", this.onGlobalMouseMove);
    document.removeEventListener("mouseup", this.onGlobalMouseUp);
  }

  @Watch("showRecycler")
  onRecyclerOpen(): void {
    if (this.showRecycler) {
      this.loadRecycler();
    }
  }

  // ==================== DATA LOADING ====================

  async loadRestaurants(): Promise<void> {
    this.loading = true;
    try {
      const res = await RestaurantAPI.getAll({ deleted: { value: false } });
      this.restaurants = res.data;
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  async selectRestaurant(r: IRestaurant): Promise<void> {
    try {
      const res = await RestaurantAPI.getById(r._id);
      this.selectedRestaurant = res.data;
      this.localTables = JSON.parse(JSON.stringify(res.data.tables || []));
      this.localWalls = JSON.parse(JSON.stringify(res.data.walls || []));
      this.localPlanWidth = res.data.planWidth || 1360;
      this.localPlanHeight = res.data.planHeight || 700;
      this.localPlanBackground = res.data.planBackground || "";
      this.selectedTableIdx = null;
      this.selectedWallIdx = null;
      this.hasChanges = false;
    } catch (e) {
      console.error(e);
    }
  }

  deselectRestaurant(): void {
    if (this.hasChanges) {
      if (!confirm(this.$t("restourant.editor.confirmExit") as string)) return;
    }
    this.selectedRestaurant = null;
    this.localTables = [];
    this.localWalls = [];
    this.selectedTableIdx = null;
    this.selectedWallIdx = null;
    this.hasChanges = false;
    this.drawingWall = null;
  }

  async loadRecycler(): Promise<void> {
    this.recyclerLoading = true;
    try {
      const res = await RestaurantAPI.getAll({ deleted: { value: true } });
      this.recyclerItems = res.data;
    } catch (e) {
      console.error(e);
    } finally {
      this.recyclerLoading = false;
    }
  }

  // ==================== RESTAURANT CRUD ====================

  async createRestaurant(): Promise<void> {
    if (!this.newRestaurant.name.ru && !this.newRestaurant.name.en) {
      alert(this.$t("restourant.editor.nameRequired") as string);
      return;
    }
    try {
      await RestaurantAPI.add({
        name: { ...this.newRestaurant.name },
        description: { ...this.newRestaurant.description },
        show: true,
        planWidth: 1360,
        planHeight: 700,
        tables: [],
        walls: [],
      });
      this.showAddModal = false;
      this.newRestaurant = {
        name: { ru: "", en: "" },
        description: { ru: "", en: "" },
      };
      await this.loadRestaurants();
    } catch (e) {
      console.error(e);
    }
  }

  openEditModal(): void {
    if (!this.selectedRestaurant) return;
    this.editLocale = preferred_language;
    this.editData = {
      name: { ...(this.selectedRestaurant.name || { ru: "", en: "" }) },
      description: {
        ...(this.selectedRestaurant.description || { ru: "", en: "" }),
      },
    };
    this.showEditModal = true;
  }

  async saveRestaurantInfo(): Promise<void> {
    if (!this.selectedRestaurant) return;
    try {
      await RestaurantAPI.updateById(this.selectedRestaurant._id, {
        name: { ...this.editData.name },
        description: { ...this.editData.description },
      });
      this.selectedRestaurant = {
        ...this.selectedRestaurant,
        name: { ...this.editData.name },
        description: { ...this.editData.description },
      };
      this.showEditModal = false;
      await this.loadRestaurants();
      this.$notify({
        group: "global",
        title: this.$t("restourant.editor.savedTitle") as string,
        text: this.$t("restourant.editor.saved") as string,
        type: "success",
      });
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        title: this.$t("restourant.editor.errorTitle") as string,
        text: this.$t("restourant.editor.saveError") as string,
        type: "error",
      });
    }
  }

  async deleteRestaurant(id: string): Promise<void> {
    const result = await this.$bvModal.msgBoxConfirm(
      this.$t("restourant.editor.confirmDelete") as string,
      { title: this.$t("restourant.editor.confirmTitle") as string }
    );
    if (result !== true) return;
    try {
      await RestaurantAPI.deleteById(id);
      await this.loadRestaurants();
    } catch (e) {
      console.error(e);
    }
  }

  async restoreRestaurant(id: string): Promise<void> {
    const result = await this.$bvModal.msgBoxConfirm(
      this.$t("restourant.editor.confirmRestore") as string,
      { title: this.$t("restourant.editor.confirmTitle") as string }
    );
    if (result !== true) return;
    try {
      await RestaurantAPI.restoreById(id);
      await this.loadRecycler();
      await this.loadRestaurants();
    } catch (e) {
      console.error(e);
    }
  }

  async forceDeleteRestaurant(id: string): Promise<void> {
    const result = await this.$bvModal.msgBoxConfirm(
      this.$t("restourant.editor.confirmForceDelete") as string,
      { title: this.$t("restourant.editor.confirmTitle") as string }
    );
    if (result !== true) return;
    try {
      await RestaurantAPI.forceDeleteById(id);
      await this.loadRecycler();
    } catch (e) {
      console.error(e);
    }
  }

  async saveAll(): Promise<void> {
    if (!this.selectedRestaurant) return;
    try {
      await RestaurantAPI.updatePlan(this.selectedRestaurant._id, {
        tables: this.localTables,
        walls: this.localWalls,
        planWidth: this.localPlanWidth,
        planHeight: this.localPlanHeight,
        planBackground: this.localPlanBackground,
      });
      this.hasChanges = false;
      this.$notify({
        group: "global",
        title: "Сохранено",
        text: "План ресторана обновлён",
        type: "success",
      });
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        title: "Ошибка",
        text: "Не удалось сохранить",
        type: "error",
      });
    }
  }

  // ==================== TABLE OPERATIONS ====================

  addTable(type: IRestaurantTable["type"], w: number, h: number): void {
    const maxNum = this.localTables.reduce((max, t) => {
      const n = parseInt(t.number);
      return !isNaN(n) && n > max ? n : max;
    }, 0);
    const newTable: IRestaurantTable = {
      number: String(maxNum + 1),
      type,
      x: this.snap(50),
      y: this.snap(50),
      width: w,
      height: h,
      rotation: 0,
      capacity: 4,
      status: "active",
    };
    this.localTables.push(newTable);
    this.selectedTableIdx = this.localTables.length - 1;
    this.selectedWallIdx = null;
    this.markChanged();
  }

  deleteSelectedTable(): void {
    if (this.selectedTableIdx === null) return;
    this.localTables.splice(this.selectedTableIdx, 1);
    this.selectedTableIdx = null;
    this.markChanged();
  }

  tableStyle(tbl: IRestaurantTable): Record<string, string> {
    return {
      left: tbl.x + "px",
      top: tbl.y + "px",
      width: tbl.width + "px",
      height: tbl.height + "px",
      transform: "rotate(" + tbl.rotation + "deg)",
    };
  }

  // ==================== WALL OPERATIONS ====================

  startWallDraw(type: IRestaurantWall["type"]): void {
    this.drawingWall = type;
    this.selectedTableIdx = null;
    this.selectedWallIdx = null;
  }

  wallColor(type: IRestaurantWall["type"]): string {
    const colors: Record<string, string> = {
      wall: "#333333",
      door: "#8B4513",
      window: "#4FC3F7",
      column: "#666666",
      bar: "#FF8F00",
    };
    return colors[type] || "#333333";
  }

  wallTypeLabel(type: IRestaurantWall["type"]): string {
    const labels: Record<string, string> = {
      wall: "Стена",
      door: "Дверь",
      window: "Окно",
      column: "Колонна",
      bar: "Барная стойка",
    };
    return labels[type] || type;
  }

  deleteSelectedWall(): void {
    if (this.selectedWallIdx === null) return;
    this.localWalls.splice(this.selectedWallIdx, 1);
    this.selectedWallIdx = null;
    this.markChanged();
  }

  // ==================== SELECTION ====================

  selectWall(idx: number): void {
    this.selectedWallIdx = idx;
    this.selectedTableIdx = null;
  }

  unselectObject(): void {
    if (this.drawingWall) return;
    this.selectedTableIdx = null;
    this.selectedWallIdx = null;
  }

  // ==================== DRAG & DROP ====================

  startTableDrag(e: MouseEvent, idx: number): void {
    this.selectedTableIdx = idx;
    this.selectedWallIdx = null;
    this.wallDragData = null;
    const tbl = this.localTables[idx];
    this.dragData = {
      tableIdx: idx,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startTableX: tbl.x,
      startTableY: tbl.y,
    };
  }

  startWallDrag(e: MouseEvent, idx: number): void {
    this.selectedWallIdx = idx;
    this.selectedTableIdx = null;
    this.dragData = null;
    const wall = this.localWalls[idx];
    this.wallDragData = {
      wallIdx: idx,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startWallX1: wall.x1,
      startWallY1: wall.y1,
      startWallX2: wall.x2,
      startWallY2: wall.y2,
    };
  }

  onGlobalMouseMove(e: MouseEvent): void {
    if (this.dragData) {
      const tbl = this.localTables[this.dragData.tableIdx];
      if (!tbl) return;
      let newX =
        this.dragData.startTableX + (e.clientX - this.dragData.startMouseX);
      let newY =
        this.dragData.startTableY + (e.clientY - this.dragData.startMouseY);
      newX = Math.max(0, Math.min(newX, this.localPlanWidth - tbl.width));
      newY = Math.max(0, Math.min(newY, this.localPlanHeight - tbl.height));
      tbl.x = this.snap(newX);
      tbl.y = this.snap(newY);
      this.markChanged();
    }

    if (this.wallDragData) {
      const wall = this.localWalls[this.wallDragData.wallIdx];
      if (!wall) return;
      const dx = e.clientX - this.wallDragData.startMouseX;
      const dy = e.clientY - this.wallDragData.startMouseY;
      wall.x1 = this.snap(this.wallDragData.startWallX1 + dx);
      wall.y1 = this.snap(this.wallDragData.startWallY1 + dy);
      wall.x2 = this.snap(this.wallDragData.startWallX2 + dx);
      wall.y2 = this.snap(this.wallDragData.startWallY2 + dy);
      this.markChanged();
    }

    if (this.drawingWall) {
      const canvas = this.$refs.canvas as HTMLElement;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      this.drawCurrent = {
        x: this.snap(e.clientX - rect.left),
        y: this.snap(e.clientY - rect.top),
      };
    }
  }

  onGlobalMouseUp(e: MouseEvent): void {
    if (this.dragData) {
      this.dragData = null;
    }
    if (this.wallDragData) {
      this.wallDragData = null;
    }

    if (this.drawingWall) {
      const canvas = this.$refs.canvas as HTMLElement;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      const x = this.snap(e.clientX - rect.left);
      const y = this.snap(e.clientY - rect.top);

      if (this.drawStart.x === 0 && this.drawStart.y === 0) {
        this.drawStart = { x, y };
      } else {
        const newWall: IRestaurantWall = {
          type: this.drawingWall,
          x1: this.drawStart.x,
          y1: this.drawStart.y,
          x2: x,
          y2: y,
          thickness: this.drawingWall === "column" ? 20 : 10,
          color: this.wallColor(this.drawingWall),
        };
        this.localWalls.push(newWall);
        this.selectedWallIdx = this.localWalls.length - 1;
        this.selectedTableIdx = null;
        this.drawingWall = null;
        this.drawStart = { x: 0, y: 0 };
        this.drawCurrent = { x: 0, y: 0 };
        this.markChanged();
      }
    }
  }

  onKeyDown(e: KeyboardEvent): void {
    if (e.key === "Escape") {
      this.drawingWall = null;
      this.drawStart = { x: 0, y: 0 };
      this.selectedTableIdx = null;
      this.selectedWallIdx = null;
    }
    if (e.key === "Delete" || e.key === "Backspace") {
      if (this.selectedTableIdx !== null) {
        this.deleteSelectedTable();
      } else if (this.selectedWallIdx !== null) {
        this.deleteSelectedWall();
      }
    }
  }

  markChanged(): void {
    this.hasChanges = true;
  }

  snap(v: number): number {
    if (!this.snapToGrid) return v;
    return Math.round(v / this.gridSize) * this.gridSize;
  }
}
